import Vue from "vue";
import Vuetify from "vuetify/lib";
import "vuetify/dist/vuetify.min.css";
Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        "tway-morado": "#4a148c",
        "tway-violeta": "#7319d5",
        "tway-verde-manzana": "#16c62e",
        "tway-verde-2": "#d2ed84",
        "tway-grey": "#f1f1f1",
        "tway-gris": "#333333",
      },
    },
  },
});
